import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../../assets/Colors';

export const useStyles = makeStyles({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.background.mainDark,
    },
    instructionsWrapper: {
        padding: '0px 5%',
        overflowY: 'auto',
    },
    text: {
        fontSize: 15,
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
        color: Colors.text.light,
        lineHeight: '1.2em',
    },
    instructionsTitle: {
        fontSize: 30,
        fontWeight: 600,
    },
    instructionsSubTitle: {
        fontSize: 18,
        fontWeight: 400,
        margin: '10px 0px',
    },
    textAlignCenter: {
        textAlign: 'center',
    },
    buttonText: {
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
        fontSize: 18,
        fontWeight: 400,
    },
    mainButton: {
        backgroundColor: Colors.main.primary,
        color: 'white',
        borderRadius: 30,
        textTransform: 'none',
        padding: '10px 40px',
        margin: '10px 0px',

        '&:hover': {
            backgroundColor: Colors.main.active,
        },
    },
    hoverButton: {
        backgroundColor: Colors.main.active,
    },
    instructionIcon: {
        width: 40,
        height: 40,
        padding: 5,
        border: '1px solid white',
        borderRadius: '50%',
    },
    textContainer: {
        margin: '5px 20px',
    },
    instructionTitle: {
        color: Colors.main.primary,
        fontSize: 18,
        marginBottom: 7.5,
    },
    flex: {
        display: 'flex',
    },
    row: {
        flexDirection: 'row',
    },
    column: {
        flexDirection: 'column',
    },
    instructionText: {},
});
